import AppraisalDetail from "../../appraisal/appraisal-detail/AppraisalDetail";

export default function ViewAppraisal() {
  return <AppraisalDetail />;
}
